import { QueryHookOptions, useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { TeamNode, UserNode } from '../../typeDeclarations/graphql/nodes';
import { useIsLoggedInQuery } from './useIsLoggedInQuery';

export interface UserTeamAvatarQueryFragmentData {
  sessionUser: Pick<UserNode, 'id' | 'ddtId' | 'email' | 'name' | 'picture'>;
  sessionTeam: Pick<TeamNode, 'id' | '_id' | 'name' | 'numUsers'>;
}

export const USER_TEAM_AVATAR_QUERY_FRAGMENT = gql(/* GraphQL */ `
  fragment UserTeamAvatarQueryFragment on Query {
    sessionUser {
      id
      ddtId
      modified
      email
      name
      picture {
        id
        url
      }
    }
    sessionTeam {
      id
      modified
      _id
      name
      numUsers
    }
  }
`);

const GET_USER_AVATAR_QUERY = gql(/* GraphQL */ `
  query userTeamAvatarQuery {
    ...UserTeamAvatarQueryFragment
  }
`);

type UserTeamAvatarQueryData = UserTeamAvatarQueryFragmentData;

export function useGetUserAvatar(options?: QueryHookOptions<UserTeamAvatarQueryData>) {
  const { data, loading } = useIsLoggedInQuery();

  return useQuery<UserTeamAvatarQueryData>(GET_USER_AVATAR_QUERY, {
    ...options,
    skip: !data?.isLoggedIn || loading,
  });
}
